import {
  IconBuildings,
  IconCalendar,
  IconDatabase,
  IconFileSearch,
  IconForms,
  IconLayoutDashboard,
  IconListCheck,
  IconListDetails,
  IconReorder,
  IconRestore,
  IconUsers,
} from "@tabler/icons-react";

const sideBarIconSize = 22;

type SidebarItem = {
  label: string;
  icon: JSX.Element;
  path?: string;
  submenu?: SidebarItem[];
};

type SidebarItems = {
  [role: string]: SidebarItem[];
};

export const sidebarItems: SidebarItems = {
  Super_Admin: [
    {
      label: "Dashboard",
      icon: <IconLayoutDashboard color="black" size={sideBarIconSize} />,
      path: "/app/dashboard",
    },
    {
      label: "Manage LEA",
      icon: <IconBuildings color="black" size={sideBarIconSize} />,
      path: "/app/manage-leas",
    },
    // {
    //   label: "Assignment Library",
    //   icon: <IconListDetails color="black" size={sideBarIconSize} />,
    //   path: "/app/assignment-master",
    // },
    {
      label: "Reports",
      icon: <IconFileSearch color="black" size={sideBarIconSize} />,
      path: "/app/reports",
    },
  ],
  LEA_Admin: [
    {
      label: "Dashboard",
      icon: <IconLayoutDashboard color="black" size={sideBarIconSize} />,
      path: "/app/dashboard",
    },
    // {
    //   label: "Manage Admins",
    //   icon: <IconBuildings color="black" size={sideBarIconSize} />,
    //   path: "/app/manage-admins",
    // },
    {
      label: "Manage Schools",
      icon: <IconBuildings color="black" size={sideBarIconSize} />,
      path: "/app/manage-schools",
    },
    {
      label: "Recovery Requests",
      icon: <IconReorder color="black" size={sideBarIconSize} />,
      path: "/app/recovery-requests",
    },
    {
      label: "All IS Requests",
      icon: <IconListDetails color="black" size={sideBarIconSize} />,
      path: "/app/all-recovery-requests",
    },
    // {
    //   label: "Assignment Master",
    //   icon: <IconListDetails color="black" size={sideBarIconSize} />,
    //   path: "/app/assignment-master",
    // },
    {
      label: "Reports",
      icon: <IconFileSearch color="black" size={sideBarIconSize} />,
      path: "/app/reports",
    },
  ],
  School_Admin: [
    {
      label: "Dashboard",
      icon: <IconLayoutDashboard color="black" size={sideBarIconSize} />,
      path: "/app/dashboard",
    },
    {
      label: "Recovery Requests",
      icon: <IconReorder color="black" size={sideBarIconSize} />,
      path: "/app/recovery-requests",
    },
    {
      label: "All IS Requests",
      icon: <IconListDetails color="black" size={sideBarIconSize} />,
      path: "/app/all-recovery-requests",
    },
    {
      label: "Reports",
      icon: <IconFileSearch color="black" size={sideBarIconSize} />,
      path: "/app/reports",
    },
    {
      label: "School Data",
      icon: <IconDatabase color="black" size={sideBarIconSize} />,
      path: "/app/master/others",
    },
    {
      label: "Users",
      icon: <IconUsers color="black" size={sideBarIconSize} />,
      path: "/app/school-users",
    },
    {
      label: "SIS Import",
      icon: <IconUsers color="black" size={sideBarIconSize} />,
      path: "/app/SIS-Import",
    },
  ],
  Parent: [
    {
      label: "Recovery Requests",
      icon: <IconReorder color="black" size={sideBarIconSize} />,
      // path: "/app/attendance-recovery",
      submenu: [
        {
          label: "List",
          icon: <IconListDetails color="black" size={sideBarIconSize} />,
          path: "/app/attendance-recovery/list",
        },
        {
          label: "Calendar",
          icon: <IconCalendar color="black" size={sideBarIconSize} />,
          path: "/app/attendance-recovery/calendar",
        },
      ],
    },
    {
      label: "Pending Approvals",
      icon: <IconListDetails color="black" size={sideBarIconSize} />,
      path: "/app/recovery-requests",
    },
  ],
  Teacher: [
    {
      label: "Recovery Requests",
      icon: <IconReorder color="black" size={sideBarIconSize} />,
      path: "/app/recovery-requests",
    },

    {
      label: "Submissions",
      icon: <IconListCheck color="black" size={sideBarIconSize} />,
      path: "/app/submitted-assignments",
    },
    {
      label: "All IS",
      icon: <IconListDetails color="black" size={sideBarIconSize} />,
      path: "/app/all-recovery-requests",
    },
  ],
  Student: [
    {
      label: "Assignments",
      icon: <IconLayoutDashboard color="black" size={sideBarIconSize} />,
      path: "/app/assignments",
    },
    {
      label: "Downloaded Materials",
      icon: <IconListDetails color="black" size={sideBarIconSize} />,
      path: "/app/downloaded-meterials",
    },
  ],
  AttandanceCoordinator: [
    // {
    //   label: "Approval",
    //   icon: <IconListCheck color="black" size={sideBarIconSize} />,
    //   path: "/app/submitted-assignments",
    // },
    {
      label: "Approval",
      icon: <IconRestore color="black" size={sideBarIconSize} />,
      path: "/app/recovery-requests",
    },
    {
      label: "Recovery Form",
      icon: <IconForms color="black" size={sideBarIconSize} />,
      path: "/app/attendance-recovery-manual-form",
    },
    {
      label: "All IS Requests",
      icon: <IconListDetails color="black" size={sideBarIconSize} />,
      path: "/app/all-recovery-requests",
    },

    {
      label: "Reports",
      icon: <IconFileSearch color="black" size={sideBarIconSize} />,
      path: "/app/reports",
    },
  ],
  Clerk: [
    {
      label: "Recovery Form",
      icon: <IconForms color="black" size={sideBarIconSize} />,
      path: "/app/attendance-recovery-manual-form",
    },
    {
      label: "Recovery Requests",
      icon: <IconRestore color="black" size={sideBarIconSize} />,
      path: "/app/recovery-requests",
    },
    {
      label: "All IS Requests",
      icon: <IconListDetails color="black" size={sideBarIconSize} />,
      path: "/app/all-recovery-requests",
    },
    {
      label: "Assignments",
      icon: <IconListCheck color="black" size={sideBarIconSize} />,
      path: "/app/submitted-assignments",
    },
    {
      label: "Reports",
      icon: <IconFileSearch color="black" size={sideBarIconSize} />,
      path: "/app/reports",
    },
  ],
};
